import { faCalendar, faCalendarTimes, faClock, faDollarSign, faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@ui';
import moment from 'moment';
import { useRouter } from 'next/router';
import React from 'react';
import { SearchTileProps } from '../SearchTile';
import { BaseTile } from './BaseTile';

interface Props extends SearchTileProps {}

export const EventTile: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ item }) => {
    const { push } = useRouter();

    const start = moment(item?.start);
    const end = moment(item?.end);
    const deadline = moment(item?.deadline);

    return (
        <div className="tw-relative">
            <Badge className="tw-absolute -tw-right-2 -tw-top-2 tw-z-20" color="light" size="md">
                Event
                <FontAwesomeIcon className="ml-2" icon={faCalendar} />
            </Badge>
            <BaseTile
                onPress={() => push(`/club/${item.slug}`)}
                title={item.title}
                subtitle={'von ' + item.club_title}
                headerImageId={item.header}
                imageId={item.logo || 'null'}
            >
                <div className="tw-heading-3 tw-grid tw-grid-cols-[auto_1fr] tw-items-center tw-gap-x-2 tw-text-accents-8">
                    {item.start && (
                        <>
                            <FontAwesomeIcon size="xs" icon={faPlayCircle} />
                            <small>
                                {`${start.format('ddd')} ${start.format('DD.MM.YYYY')}${
                                    item.end ? ` bis ${end.format('ddd')} ${end.format('DD.MM.YYYY')}` : ''
                                }`}
                            </small>
                        </>
                    )}

                    {typeof item.start_time === 'number' && (
                        <>
                            <FontAwesomeIcon size="xs" icon={faClock} />
                            <small>{`${item.start_time} bis ${item.end_time}`}</small>
                        </>
                    )}

                    {item.deadline && (
                        <>
                            <FontAwesomeIcon size="xs" icon={faCalendarTimes} />
                            <small>{`${deadline.format('ddd')} ${deadline.format('DD.MM.YYYY')}`}</small>
                        </>
                    )}

                    {item.online_payments && (
                        <>
                            <FontAwesomeIcon size="xs" icon={faDollarSign} />
                            <small>Direkt online Bezahlen</small>
                        </>
                    )}
                </div>
            </BaseTile>
        </div>
    );
};
